module.exports = __webpack_public_path__ + "static/media/icon-expand.ba8d05b9.svg";